export function slugFromDomain(input: string): string {
  const trimmed = input.trim().toLowerCase();
  if (!trimmed) return "";

  let host = trimmed;
  const protoIdx = host.indexOf("://");
  if (protoIdx >= 0) host = host.slice(protoIdx + 3);
  const slashIdx = host.indexOf("/");
  if (slashIdx >= 0) host = host.slice(0, slashIdx);
  const colonIdx = host.indexOf(":");
  if (colonIdx >= 0) host = host.slice(0, colonIdx);
  if (host.startsWith("www.")) host = host.slice(4);

  const firstLabel = host.split(".").find(Boolean);
  if (!firstLabel) return "";

  return firstLabel
    .replace(/[^a-z0-9-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40);
}
